<div class="module-contact-body" [ngSwitch]="template">
    <div class="module contact" *ngSwitchCase="null">
        <div class="module-title">
            <h3>{{data.titulo}}</h3>
        </div> 
        <div class="module-content">
            <ul>
                <li>
                    <div class="icon">
                        <i class="material-icons">phone</i>
                    </div>
                    <div class="text">
                        <a href="tel:{{data.params.celular}}">{{data.params.celular}}</a>
                    </div>    
                </li>
                <li>
                    <div class="icon">
                        <i class="material-icons">email</i>
                    </div>
                    <div class="text">
                        <a href="mailto:{{data.params.email}}">{{data.params.email}}</a>
                    </div>    
                </li>    
            </ul>    
        </div>      
    </div>
    <div class="module two" *ngSwitchCase="'two'">
        <div class="contact-list-module">
            <div class="container">
                <div class="center">
                    <ul>
                        <li (click)="_click()" class="wow fadeIn">
                            <div class="icon">
                                <img src="/images/icons/whatsapp-01.svg" alt="WhatsApp" width="45px" />
                            </div>
                            <div class="text">
                                <strong>WhatsApp</strong>
                                <span>{{data.params.whatsapp}}</span>
                            </div>    
                        </li>
                        <li class="wow fadeIn" data-wow-delay="0.2s">
                            <div class="icon">
                                <img src="/images/icons/email.svg" alt="E-mail" width="45px" />
                            </div>
                            <div class="text">
                                <strong>Nos envie uma mensagem</strong>
                                <a routerLink="/contato" title="Contato">
                                    Clicando aqui
                                </a>
                            </div>    
                        </li> 
                        <li class='divisor'>   
                            <span></span>
                        </li>
                        <li class="redes-sociais wow fadeIn" data-wow-delay="0.3s">
                            <strong>Redes Sociais</strong>
                        </li>
                        <li (click)="toInstagram()" class="wow fadeIn" data-wow-delay="0.4s">
                            <div class="icon icon-rede-social">
                                <img src="/images/icons/instagram.svg" alt="Instagram" width="45px" />
                            </div>
                            <div class="text">
                                <strong>Instagram</strong>
                                <span>{{data.params.instagram_conta}}</span>
                            </div>
                        </li>
                        <li (click)="toFacebook()" class="wow fadeIn" data-wow-delay="0.6s">
                            <div class="icon icon-rede-social">
                                <img src="/images/icons/facebook.svg" alt="Facebook" width="45px" />
                            </div>
                            <div class="text">
                                <strong>Facebook</strong>
                                <span>{{data.params.facebook_conta}}</span>
                            </div>
                        </li>    
                    </ul>
                </div>  
            </div>  
        </div>      
    </div>
    <div class="module module-page-contato" *ngSwitchCase="'page-contato'">
        <div class="module-content">
            <ul>
                <li>
                    <div class="icon">
                        <i class="material-icons">phone</i>
                    </div>
                    <div class="text">
                        <a href="tel:{{data.params.celular}}">{{data.params.celular}}</a>
                    </div>    
                </li>
                <li>
                    <div class="icon">
                        <i class="material-icons">whatsapp</i>
                    </div>
                    <div class="text">
                        <a href="javascript::void();" (click)="_click()">
                            Fale pelo WhatsApp.
                        </a>
                    </div>    
                </li> 
                <li>
                    <div class="icon">
                        <img src="/images/icons/facebook.svg" alt="Facebook" width="20px" height="20px" />
                    </div>
                    <div class="text">
                        <a [href]="data.params.facebook" target="_blank">
                            {{data.params.facebook_conta}}
                        </a>
                    </div>    
                </li>  
                <li>
                    <div class="icon">
                        <img src="/images/icons/instagram.svg" alt="Instagram" width="20px" height="20px" />
                    </div>
                    <div class="text">
                        <a [href]="data.params.instagram" target="_blank">
                            {{data.params.instagram_conta}}
                        </a>
                    </div>    
                </li>    
            </ul>
        </div>    
    </div>    
</div>    
